import { makeStyles } from '@material-ui/core';

import { Loader } from 'assets';

export default makeStyles((theme) => ({
  docuSignBox: {
    padding: '50px 168px 35px 188px',
    '@media (max-width: 1125px)': {
      padding: '50px 5% 35px',
    },
    '@media (max-width: 1024px)': {
      padding: '0px 5% 35px',
    },
    '@media (max-width: 767px)': {
      padding: '0px 5% 15px',
    },
  },
  iframeContainer: {
    backgroundImage: `url(${Loader})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    width: '96%',
    height: '100%',
    position: 'absolute',
    zIndex: 99,
  },
  investNowFormHeader: {
    fontSize: 32,
    letterSpacing: 0.3,
    color: theme.palette.warning.contrastText,
    marginBottom: 30,
    fontWeight: 400,
    '@media (max-width: 525px)': {
      fontSize: 20,
      margin: '0px 0 20px',
    },
  },
  docuSignText: {
    fontSize: 15,
    letterSpacing: 0.35,
    color: theme.palette.grey[50],
    marginBottom: 20,
    fontWeight: 400,
    lineHeight: '28px',
  },
  eSignCompletedText: {
    fontSize: 15,
    letterSpacing: 0.35,
    color: theme.palette.grey[50],
    marginBottom: 10,
    marginTop: 10,
    fontWeight: 400,
    lineHeight: '28px',
  },
  listMenu: {},
  listItem: {
    fontSize: 15,
    letterSpacing: 0.35,
    color: theme.palette.grey[50],
    marginBottom: 10,
    fontWeight: 400,
    lineHeight: '18px',
  },
  signButton: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    borderRadius: 10,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 800,
    width: 273,
    fontSize: 16,
    cursor: 'pointer',
    height: 48,
    letterSpacing: 0.3,
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText,
    },
  },
  nextPrevButtonBox: {
    paddingTop: 30,
    display: 'flex',
    paddingBottom: 10,
  },
  prevButton: {
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.secondary.main,
    borderRadius: 10,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 800,
    width: 152,
    fontSize: 16,
    cursor: 'pointer',
    height: 57,
    letterSpacing: 0.3,
    marginRight: 18,
    textTransform: 'capitalize',
    border: '1px solid',
    borderColor: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: theme.palette.warning.main,
      color: theme.palette.secondary.light,
      borderColor: theme.palette.secondary.light,
    },
  },
  nextButton: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    borderRadius: 10,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 800,
    width: 152,
    fontSize: 16,
    cursor: 'pointer',
    height: 57,
    letterSpacing: 0.3,
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText,
    },
  },
}));
